import { usePrismicContext } from "./usePrismicContext.js";
const usePrismicClient = (explicitClient) => {
  const context = usePrismicContext();
  const client = explicitClient || (context == null ? void 0 : context.client);
  if (!client) {
    throw new Error("A @prismicio/client is required to query documents. Provide a client to the hook or to a <PrismicProvider> higher in your component tree.");
  }
  return client;
};
export {
  usePrismicClient
};
//# sourceMappingURL=usePrismicClient.js.map
